// This store is for the Interview courses for the login users.
/*eslint-disable */
import toast from '../services/toast'
import axios from 'axios';
import root from '../_helpers/roots';
import router from '../route';
// Get Interview courses
let interViewCourseDetailsURL = root.interViewCourseDetailsUrl.link;
let interViewCourseSectionDetailsURL = root.interViewCourseSectionDetailsUrl.link;

export default {
  state: {
    setInterviewCourseState: {},
    setInterviewCourseSectionState:{}
  },
  mutations: {
    setInterviewCourseMutation(state, response) {
      state.setInterviewCourseState = response;
    },
    setInterviewCourseSectionMutation(state, response) {
      state.setInterviewCourseSectionState = response;
    }
  },
  actions: {
    getInterviewCourseDetails(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get(interViewCourseDetailsURL  + payload.id + '/').then((response) => {
          context.commit('setInterviewCourseMutation', response.data);
            resolve(response);
          })
          .catch(function(error) {
            reject(error);
          });
      })
    },
    getInterviewCourseInSectionDetails(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get(interViewCourseSectionDetailsURL + payload.id + '/').then((response) => {
          context.commit('setInterviewCourseSectionMutation', response.data);
            resolve(response);
          })
          .catch(function(error) {
            reject(error);
          });
      })
    }
  },
  getters: {
    getInterviewCourseGetters: state => state.setInterviewCourseState,
    getInterviewCourseSectionGetters: state => state.setInterviewCourseSectionState
  }
}